import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { verifySession } from "../helpers/sessions"; // Update the path as needed
import { tokenHelper } from "../stores/helpers";
import { useAuth } from "../stores/Auth/Auth";
import { Spinner } from "reactstrap";

export const RootProtected = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(null);
  const [user, setUser] = useState(null);
  const { verifyToken } = useAuth((state) => state); // Assuming verifySession is passed as a prop
  useEffect(() => {
    const checkAuth = async () => {
      setIsLoading(true);

      const result = await verifyToken();

      if (result) {
        const userfetched = await tokenHelper.getUser();

        setUser(userfetched); // Assuming you get userId or user object
        setIsAuth(true);
      } else {
        setIsAuth(false);
      }
      setIsLoading(false);
    };

    checkAuth();
  }, [verifySession]);

  if (isLoading) {
    // Show a loading spinner or some placeholder
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner size={"sm"} />
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  // Assuming you have a way to check for temporary passwords
  // This part needs to be integrated based on your actual logic
  // For now, we're assuming that `user` object might have a `tempPassword` property
  if (user && user?.tempPassword) {
    return <Navigate to="/reset-password" />;
  }

  if (user && user.role !== "ROOT") {
    return <Navigate to="/dashboard" />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};
